import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { BreadcrumbMenuObject } from '@libs/types/src/user/object-type/breadcrumb-menu.object';
import { BreadcrumbMenuUpsertInput } from '@libs/types/src/user/input-type/breadcrumb-menu.upsert-input';

@Injectable({ providedIn: 'root' })
export class BreadcrumbMenuGqlService extends GqlServiceV2 {

    public async getBreadcrumbMenus(input: any = null, fragment: string): Promise<BreadcrumbMenuObject[]> {
        return this.query(
            `
                query {
                    breadcrumbMenu {
                        currentUser {
                            ${fragment}
                        }
                    }
                }
            `,
        );
    }

    public async upsertBreadcrumbMenu(input: BreadcrumbMenuUpsertInput, fragment: string): Promise<BreadcrumbMenuObject> {
        return this.mutate(
            `
                mutation ($input: BreadcrumbMenuUpsertInput!) {
                    breadcrumbMenu {
                        upsert(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

}
